import messages from '../../../messages';

export const eventsSchemaEnhancer = ({ schema, formData, intl }) => {
  const isThisVariation =
    formData?.variation === 'events' || formData?.template === 'events';
  if (!isThisVariation) return schema;

  const add = (key, def) => {
    schema.properties[key] = def;
    const fs =
      schema.fieldsets?.find((f) => f.id === 'default') ||
      schema.fieldsets?.[0];
    if (fs && !fs.fields.includes(key)) fs.fields.push(key);
  };

  add('eventDate1', { title: 'Event 1 – Date', type: 'string' });
  add('eventTime1', { title: 'Event 1 – Time', type: 'string' });
  add('eventDate2', { title: 'Event 2 – Date', type: 'string' });
  add('eventTime2', { title: 'Event 2 – Time', type: 'string' });
  add('eventDate3', { title: 'Event 3 – Date', type: 'string' });
  add('eventTime3', { title: 'Event 3 – Time', type: 'string' });

  add('moreLinkLabel', {
    title: 'Footer-Link: Text',
    type: 'string',
    default: 'Alle Veranstaltungen anzeigen',
  });
  add('moreLinkHref', {
    title: 'Footer-Link: Ziel',
    widget: 'object_browser',
    mode: 'link',
    description: intl.formatMessage(messages.listingFootnote),
  });

  return schema;
};
